import api from './api';


export const getProductRequests = async (params = {}) => {
  const response = await api.get('/admin/product-requests/', { params });
  return response.data;
};

export const getProductRequest = async (requestId) => {
  const response = await api.get(`/admin/product-requests/${requestId}/`);
  return response.data;
};

export const updateProductRequest = async (requestId, payload) => {
  const response = await api.patch(`/admin/product-requests/${requestId}/`, payload);
  return response.data;
};

export const updateProductRequestItem = async (requestId, itemId, payload) => {
  const response = await api.patch(`/admin/product-requests/${requestId}/items/${itemId}/`, payload);
  return response.data;
};
